import { Component, OnInit } from '@angular/core';
import { Animacao } from '../../core/tools/animacao';
import { ToastrService } from 'ngx-toastr';

import { WhatsAppOfficialEtapa } from '../../core/models/whatsapp-oficial/whatsapp-oficial-etapa';

import { WhatsAppOfficialService } from '../../core/services/whatsapp-oficial/whatsapp-oficial.service';
import { WhatsAppOfficialConfiguracao } from '../../core/models/whatsapp-oficial/whatsapp-oficial-configuracao';

@Component({
    selector: 'app-whatsapp-oficial-config',
    templateUrl: './whatsapp-oficial-config.component.html',
    styleUrls: ['./whatsapp-oficial-config.component.css'],
    preserveWhitespaces: false,
    animations: [Animacao],
    standalone: false
})

export class WhatsappOficialConfigComponent implements OnInit {
  public carregando: boolean = false;
  public configuracao: WhatsAppOfficialConfiguracao = new WhatsAppOfficialConfiguracao();
  public etapas: WhatsAppOfficialEtapa[] = [];
  public novaEtapa: WhatsAppOfficialEtapa = new WhatsAppOfficialEtapa();

  public readonly is_master: boolean = (localStorage.getItem("is_master") == "true");
  public readonly is_diretor: boolean = (localStorage.getItem("is_diretor") == "true");
  public readonly is_financeiro: boolean = (localStorage.getItem("is_financeiro") == "true");
  public readonly podeEditar: boolean = this.is_master || this.is_diretor || this.is_financeiro;

  constructor(
    private toastr: ToastrService,
    private whatsAppOfficialService: WhatsAppOfficialService
  ) { }

  ngOnInit() {
    this.carregarDados();
  }

  public carregarDados() {
    this.carregando = true;

    this.whatsAppOfficialService.getConfiguration().subscribe(
      configuracao => {
        this.configuracao = configuracao != null ? configuracao : new WhatsAppOfficialConfiguracao();
      },
      error => { console.log("Erro: " + error) }
    );

    this.whatsAppOfficialService.getStages().subscribe(
      etapas => this.etapas = etapas.sort((a, b) => a.ordem - b.ordem),
      error => { console.log("Erro: " + error) },
      () => {
        this.carregando = false;
      }
    );
  }

  public salvarConfiguracao() {
    this.whatsAppOfficialService.upsertConfiguration(this.configuracao).subscribe(
      salvo => {
        if (salvo) {
          this.toastr.success("", "Configuração do WhatsApp Oficial salva com sucesso!");
          this.carregarDados();
        }
      }
    );
  }

  public adicionarEtapa() {
    if (this.novaEtapa.nome == null || this.novaEtapa.nome.trim() == "") {
      this.toastr.warning("", "Informe o nome da etapa.");
      return;
    }

    this.novaEtapa.ordem = this.getProximaOrdem();

    this.whatsAppOfficialService.addStage(this.novaEtapa).subscribe(
      adicionado => {
        if (adicionado) {
          this.toastr.success("", "Etapa adicionada com sucesso!");
          this.novaEtapa = new WhatsAppOfficialEtapa();
          this.carregarDados();
        }
      }
    );
  }

  public salvarEtapa(etapa: WhatsAppOfficialEtapa) {
    this.whatsAppOfficialService.updateStage(etapa).subscribe(
      alterado => {
        if (alterado) {
          this.toastr.success("", "Etapa atualizada com sucesso!");
          this.carregarDados();
        }
      }
    );
  }

  public excluirEtapa(etapa: WhatsAppOfficialEtapa) {
    if (etapa == null || etapa.permite_exclusao == false) {
      return;
    }

    this.whatsAppOfficialService.deleteStage(etapa.id).subscribe(
      removido => {
        if (removido) {
          this.toastr.success("", "Etapa removida com sucesso!");
          this.carregarDados();
        }
      }
    );
  }

  public moverEtapa(etapa: WhatsAppOfficialEtapa, direcao: number) {
    let etapasMoveis = this.etapas.filter(x => x.is_system == false).sort((a, b) => a.ordem - b.ordem);
    let indiceAtual = etapasMoveis.findIndex(x => x.id == etapa.id);
    let indiceDestino = indiceAtual + direcao;

    if (indiceAtual < 0 || indiceDestino < 0 || indiceDestino >= etapasMoveis.length) {
      return;
    }

    let etapaAtual = etapasMoveis[indiceAtual];
    etapasMoveis[indiceAtual] = etapasMoveis[indiceDestino];
    etapasMoveis[indiceDestino] = etapaAtual;

    let ids = etapasMoveis.map(x => x.id);

    this.whatsAppOfficialService.reorderStages(ids).subscribe(
      ordenado => {
        if (ordenado) {
          this.toastr.success("", "Etapas reordenadas com sucesso!");
          this.carregarDados();
        }
      }
    );
  }

  public getProximaOrdem(): number {
    if (this.etapas.length == 0) {
      return 3;
    }

    let etapasPipeline = this.etapas.filter(x => x.tipo == "PIPELINE");

    if (etapasPipeline.length == 0) {
      return 3;
    }

    return Math.max.apply(null, etapasPipeline.map(x => x.ordem)) + 1;
  }
}
